import React from 'react';
import './FormStyles.css';

export default function EmailInput({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  placeholder = '',
  className = '',
}) {
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const showError = error || (value && !validateEmail(value) ? 'Invalid email format' : '');

  return (
    <div className={`form-group ${className}`}>
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <input
        id={name}
        type="email"
        name={name}
        value={value || ''}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder || 'example@email.com'}
        className={`form-input ${showError ? 'error' : ''}`}
      />
      {showError && <div className="form-error">{showError}</div>}
    </div>
  );
}
